import { useEffect, useState } from "react"
import { IoSearchOutline } from "react-icons/io5"
import ApiClient from "../../methods/api/apiClient"
import moment from "moment"
import Pagination from "react-js-pagination";
import { useNavigate } from "react-router-dom"
import loader from "../../methods/loader"
import methodModel from "../../methods/methods"
import Layout from "../../components/global/layout";

const Blogs = () => {
    const [blogs, setBlogs] = useState([])
    const [recentBlogs, setRecentBlogs] = useState([])
    const [filters, setFilters] = useState({ page: 1, count: 9, search: "" })
    const [total, setTotal] = useState(0)
    const navigate = useNavigate()

    useEffect(() => {
        getBlogs()
        getRecentBlogs()
    }, [])

    const getBlogs = (p = {}) => {
        const filter = { ...filters, ...p, status: "active" }
        loader(true)
        ApiClient.get(`blog/listing`, filter).then((res) => {
            if (res.success) {
                setBlogs(res?.data)
                setTotal(res?.total)
            }
            loader(false)
        })
    }

    const getRecentBlogs = () => {
        ApiClient.get(`blog/listing?sortBy= createdAt asc&page=1&count=2`).then((res) => {
            if (res.success) {
                setRecentBlogs(res?.data)
            }
        })
    }

    const handleSearchInput = (e: any) => {
        if (!e.target.value) {
            getBlogs({ search: "" })
        }
        setFilters({ ...filters, search: e.target.value })
    }

    const handleSearch = (e: any) => {
        e.preventDefault()
        getBlogs({ search: filters?.search })
    }

    const clearSearch = () => {
        setFilters({ ...filters, search: "" })
        getBlogs({ search: "" })
    }

    const handlePagination = (e: any) => {
        setFilters({ ...filters, page: e });
        getBlogs({ page: e });
    };

    return (
        <>
        <Layout>
        <div className="wrapper_section py-6 lg:py-16 ">

            
            <div className="grid grid-cols-12 gap-6 mx-auto p-4 md:p-6 lg:p-8">
                <div className="col-span-12 md:col-span-4 lg:col-span-3 2xl:col-span-3 md:sticky md:top-5">
                    <div className="border border-black/46 bg-white shadow-md px-6 py-8 ">
                        <div className="searchbar flex items-center relative mb-4">
                            <form className="flex w-full" onSubmit={handleSearch}>
                                <div className="relative w-full">
                                    <input type="text" value={filters?.search} onChange={e => handleSearchInput(e)} className="w-full px-4 h-10 border border-gray-200 placeholder:text-gray-800 pr-10 rounded-lg" placeholder="Search blog..." required />
                                    {filters?.search && (
                                        <i className="fa fa-times absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 text-sm" aria-hidden="true" onClick={(e) => clearSearch()}></i>
                                    )}
                                </div>
                                <button type="submit" className="h-full absolute rounded-r-lg right-0 w-12 bg-primary border border-gray-200 cursor-pointer text-white py-2 flex items-center justify-center">
                                    <IoSearchOutline />
                                </button>
                            </form>
                        </div>
                        <div className="mb-4">
                            <p className="text-xl font-medium">RECENT POSTS</p>
                        </div>
                        {recentBlogs && recentBlogs?.map((item: any, index: number) => {
                            return (
                                <div className="flex md:flex-col 2xl:flex-row  bg-white p-2 rounded-md border border-gray flex-row items-center gap-2 mb-3" key={index}>
                                    <img src={methodModel.noImg(item?.image)} className="h-32 w-24 2xl:w-32 md:w-full object-cover rounded-lg" />
                                    <div className="w-full"><a href={`/blog/detail/${item?.id || item?._id}`}>
                                        <div className="flex justify-between flex-col gap-2 ">
                                           <div>
                                           <span className="bg-gray-200 py-1 px-2 rounded-lg text-black text-[11px]  font-regular capitalize">{item?.title}</span>
                                           </div>
                                            <p className="text-xs">{moment(item?.createdAt).format("LL")}</p>
                                        </div>
                                        <p className="text-[14px] font-medium mt-2 line-clamp-3 text-ellipsis" dangerouslySetInnerHTML={{ __html: item?.description }}></p>
                                    </a>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className="col-span-12 md:col-span-8 lg:col-span-9 2xl:col-span-9">
                    <h2 className="text-lg font-bold mb-2">Latest  Blogs</h2>
                    <div className="blog-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {blogs && blogs?.map((item: any, index: number) => {
                            return (
                                <div 
                                className="blog-item bg-white p-4 md:p-6 lg:p-8 rounded shadow-md cursor-pointer transition-transform duration-300 ease-in-out hover:translate-y-[-10px]" 
                                key={index} 
                                onClick={e => { navigate(`/blog/detail/${item?.id || item?._id}`) }}
                              >
                                <img 
                                  src={methodModel.noImg(item?.image)} 
                                  alt="Image 1" 
                                  className="w-full h-52 object-cover rounded-t-md" 
                                />
                                <h3 className="text-lg font-bold my-2 capitalize">{item?.title}</h3>
                                <p 
                                  className="text-sm text-gray-700 mb-4 text-ellipsis line-clamp-3" 
                                  dangerouslySetInnerHTML={{ __html: item?.description }}
                                ></p>
                                <div className="blog-meta text-sm text-gray-700 capitalize">
                                  <span>{item?.addedByDetail?.fullName || item?.addedByDetail?.firstName} || </span>
                                  <span>{moment(item?.createdAt).format("LL")}</span>
                                </div>
                                <button className="bg-primary text-white px-4 py-1 mt-4 text-xs">Read More</button>
                              </div>
                              
                            )
                        })}
                    </div>
                    <div className="mt-10 flex items-center justify-end">
                        <Pagination
                            activePage={filters?.page}
                            itemsCountPerPage={filters?.count}
                            totalItemsCount={total}
                            pageRangeDisplayed={3}
                            onChange={handlePagination}
                            hideFirstLastPages={true}
                        />
                    </div>
                </div>
            </div>
            </div>
            </Layout>
        </>
    )
}

export default Blogs